import { Tag } from "antd"
import { TagProps } from "antd/lib"
import React from "react"
import { ORANGE_SHIVVERS, PRIMARY_BLUE_SHIVVERS } from "src/app/theme"

export const PremierTag = () => {

    return <Tag style={{
        fontSize: 10, paddingInline: 4,
    }} color={ORANGE_SHIVVERS}>Premier</Tag>
}

export const PremierPlusTag = () => {

    return <Tag color={ORANGE_SHIVVERS}>Premier+</Tag>
}

export const IpTag = (props: {ip: string | null | undefined}) => {

    return <Tag color={ORANGE_SHIVVERS}
        style={{
            fontSize: 10, paddingInline: 4,
    }}
    >
        {props.ip}
    </Tag>;
}

export const OverviewCardTag = (props: TagProps) => {
    return <Tag style={{
        fontSize: 10,
        ...props.style,
    }} color={props.color ?? ORANGE_SHIVVERS}>{props.children}</Tag>
}

export const CommandCenterTag = (props: TagProps) => {
    return <OverviewCardTag>Command Center</OverviewCardTag>
}